import { ConfigState } from './reducer';

export const selectConfigState = (state: any): ConfigState => state.config;

export const selectOauthBaseUri = (state: any) =>
  selectConfigState(state).oauthBaseUri;

export const selectOauthClientId = (state: any) =>
  selectConfigState(state).oauthClientId;
